/* ============================================
   HALAL ICHIBA — 受注対応品の数量上限クランプ
   ============================================

   <input class="quantity__input" max="2"> が設定されている数量フィールドで、
   ユーザーが直接 "5" などを打ち込んだ際に、change/blur 時に max にクランプする。

   Shopify Dawn の <quantity-input> は + ボタンの stepUp() で max を尊重するが、
   直接入力では値を矯正しない。これを補完するための薄い JS。

   サーバー側強制ではない(JS無効化で迂回可能)が、誤入力の99%は止められる。
   送料コスト管理を目的とした緩いガードとして十分機能する。
*/

(function () {
  'use strict';

  function clampInput(input) {
    if (!input || input.type !== 'number') return;
    var maxAttr = input.getAttribute('max');
    if (!maxAttr) return;
    var max = parseInt(maxAttr, 10);
    if (isNaN(max)) return;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) return;
    if (current > max) {
      input.value = max;
      // 既存の change/quantityUpdate イベントを再発火させる
      input.dispatchEvent(new Event('change', { bubbles: true }));
      // 視覚的フィードバック
      input.classList.add('quantity__input--clamped');
      setTimeout(function () {
        input.classList.remove('quantity__input--clamped');
      }, 1200);
    }
  }

  function attach(input) {
    if (input.dataset.jutyuuClampBound === '1') return;
    input.dataset.jutyuuClampBound = '1';
    input.addEventListener('input', function () { clampInput(input); });
    input.addEventListener('change', function () { clampInput(input); });
    input.addEventListener('blur', function () { clampInput(input); });
  }

  function attachAll() {
    var inputs = document.querySelectorAll('input.quantity__input[max]');
    inputs.forEach(attach);
  }

  function init() {
    attachAll();
    // 動的に DOM が変わるカートドロワーやセクションリフレッシュにも追随
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        // 軽量化: 新しい input が現れた可能性のあるときだけ走査
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
            attachAll();
            return;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
